import { Button, Col, Dropdown, MenuProps, Row, notification, Tag } from 'antd';
import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfExperienceContext,
  UserExperienceDataContext,
} from '../../../../../../../context';
import { getYearMonthDiff } from '../../../../../../../utils/helper';
import DeleteModal from '../../../../../modal/delete';
import EditExperience from '../edit-experience';
import styles from './styles.module.scss';

interface ExperienceDetailProps {
  experience_id: number;
  company_name: string;
  job_responsibility: string;
  designation: any;
  start_date: any;
  end_date: any;
  show_in_resume: boolean;
}

const ExperienceDetail: React.FC<ExperienceDetailProps> = ({
  experience_id,
  company_name,
  designation,
  start_date,
  end_date,
  job_responsibility,
  show_in_resume
}: ExperienceDetailProps): JSX.Element => {
  const [iseditable, setIsEditable] = useState<boolean>(false);
  const { userExperienceData, setUserExperienceData } = useContext(
    UserExperienceDataContext
  );
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const { numberOfExperience, setNumberOfExperience } = useContext(
    NumberOfExperienceContext
  );

  const openNotification = (
    notificationType: 'success' | 'info' | 'warning' | 'error'
  ) => {
    notification[notificationType]({
      message:
        notificationType === 'info'
          ? `Deleting experience item!`
          : notificationType === 'success'
            ? `Deleted experience item Successfully`
            : notificationType === 'error'
              ? `An error occured while deleting experience item`
              : '',
    });
  };

  const handleDelete = () => {
    openNotification('info');
    let reqBody = {};
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/experiences';
      reqBody = { profile_id: employeeId, experience_id, status: 3 };
    } else {
      url = '/api/v1/profile/experiences';
      reqBody = { experience_id, status: 3 };
    }
    axiosInstance
      .post(url, reqBody)
      .then((response) => {
        const orderedExperiences = response.data.order
          .map((experienceId: number) =>
            response.data.experiences.find(
              (experience: any) => experience.experience_id === experienceId
            )
          )
          .filter((item: any) => item !== undefined);
        setUserExperienceData(orderedExperiences);
        setNumberOfExperience(orderedExperiences.length);
        openNotification('success');
      })
      .catch((error) => {
        openNotification('error');
      });
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <div
          onClick={(e) => {
            setIsEditable(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Edit</p>
        </div>
      ),
      key: '0',
    },
    {
      label: (
        <div
          onClick={() => {
            setIsDeleteModalOpen(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Delete</p>
        </div>
      ),
      key: '1',
    },
  ];

  return (
    <div>
      {isDeleteModalOpen ? (
        <DeleteModal
          {...{
            isModalOpen: isDeleteModalOpen,
            setIsModalOpen: setIsDeleteModalOpen,
            handleDelete: handleDelete,
          }}
        />
      ) : (
        <></>
      )}
      {iseditable ? (
        <EditExperience
          {...{
            experience_id,
            company_name,
            designation,
            start_date,
            end_date,
            job_responsibility,
            setIsEditable,
            show_in_resume
          }}
        />
      ) : (
        <Row
          key={experience_id}
          className={styles.row}
          gutter={{ xs: 8, sm: 16 }}
          style={{ margin: '5px', marginBottom: '10px' }}
        >
          <div style={{ display: "flex", alignItems: "center", position: "absolute", bottom: "5px", right: "5px" }}>
            {
              show_in_resume ? (
                <Tag color="success">
                  Show in resume: Yes
                </Tag>
              ) : (
                <Tag color="error">
                  Show in resume: No
                </Tag>
              )
            }
          </div>
          <Col span={12}>
            <Row>
              <h1 className={styles['skill-text']}>
                <b>{company_name}</b>
              </h1>
            </Row>
            <Row>
              <p className={styles['designation-name']}>
                {designation['designation']}
              </p>
            </Row>
            <Row>
              <div style={{ width: "100%" }}>Roles and responsibilities : </div>
              <p className={styles['designation-name']} dangerouslySetInnerHTML={{ __html: job_responsibility }} />
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={12}>
                <p>
                  <span className={styles.title}>From : </span>
                  <span className={styles.value}>{start_date}</span>
                </p>
              </Col>
              <Col span={12}>
                <p>
                  <span className={styles.title}>To : </span>
                  <span className={styles.value}>
                    {end_date ? end_date : 'Present'}
                  </span>
                </p>
              </Col>
            </Row>
            <p>
              <span className={styles.title}>Total Experience (Years) : </span>
              <span className={styles.value}>
                {end_date
                  ? getYearMonthDiff(new Date(start_date), new Date(end_date))
                  : getYearMonthDiff(new Date(start_date), new Date())}
              </span>
            </p>
          </Col>
          {iseditable ? (
            <></>
          ) : (
            <Dropdown
              menu={{ items }}
              trigger={['click']}
              placement="bottomLeft"
            >
              <Button
                type="text"
                style={{
                  position: 'absolute',
                  right: '5px',
                  border: 'hidden',
                  textDecoration: 'blue',
                  top: '10px',
                }}
              >
                <img
                  src="/more_vert.png"
                  style={{
                    marginLeft: 'auto',
                    marginRight: '0px',
                    height: '15px',
                    width: '5px',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}
                />
              </Button>
            </Dropdown>
          )}
        </Row>
      )}
    </div>
  );
};

export default ExperienceDetail;
